'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthUsage(tfa, sites, credentials) {
  this.e1 = null;
  this.xC = null;
  this.Ea = null;
  this.e1 = tfa;
  this.xC = sites;
  this.Ea = credentials;
}
export { $c_Lpresto_types$TwoFactorAuthUsage as $c_Lpresto_types$TwoFactorAuthUsage };
$p = $c_Lpresto_types$TwoFactorAuthUsage.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthUsage;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthUsage() {
}
export { $h_Lpresto_types$TwoFactorAuthUsage as $h_Lpresto_types$TwoFactorAuthUsage };
$h_Lpresto_types$TwoFactorAuthUsage.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$TwoFactorAuthUsage)) {
    var x = this.e1;
    var x$2 = x$0.e1;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.xC;
      var x$4 = x$0.xC;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Ea;
      var x$6 = x$0.Ea;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "TwoFactorAuthUsage";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.e1;
      break;
    }
    case 1: {
      return this.xC;
      break;
    }
    case 2: {
      return this.Ea;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.jk = (function() {
  return this.e1.jc;
});
function $isArrayOf_Lpresto_types$TwoFactorAuthUsage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.km)));
}
export { $isArrayOf_Lpresto_types$TwoFactorAuthUsage as $isArrayOf_Lpresto_types$TwoFactorAuthUsage };
var $d_Lpresto_types$TwoFactorAuthUsage = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthUsage, "presto.types$TwoFactorAuthUsage", ({
  km: 1,
  aA: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$TwoFactorAuthUsage as $d_Lpresto_types$TwoFactorAuthUsage };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Usage.js.map
